module.exports = __webpack_public_path__ + "453b836c18cb9418229160538b0a93e8.jpg";